import * as React from 'react'
import { Modal, Button } from 'react-bootstrap'

/*
    this class take care of the pop up page if you clock on password forgotten
*/
interface ConnexionProps {
    ChangeViewToInscription: () => void
    ChangeViewToConnexion: () => void
    updateEmail: (e: React.FormEvent<HTMLInputElement>) => void
}

interface ConnexionState {
    EmailConnexion: string,
    PasswordConnexion: string,
}

export default class PasswordModal extends React.Component<ConnexionProps, ConnexionState> {

    render() {
        return (
        <>
            <Modal.Body>
                <div className="form-group">
                    <b>Adresse e-mail</b>
                    <input className="form-control"
                        type="email"
                        placeholder="Entrer votre adresse e-mail" 
                        onInput={this.props.updateEmail}></input>
                </div>

                <div className="form-group">
                    <Button variant="link"
                    onClick={this.props.ChangeViewToInscription}
                    ><u>Inscription</u></Button>

                    <Button variant="link"
                    onClick={this.props.ChangeViewToConnexion}
                    ><u>Connexion</u></Button>
                </div>
            </Modal.Body>
        </>
        );
    }

}